export default "__VITE_ASSET__26fGMr9E__"